// Screen Breakpoints
export const MAX_SMALL_WIDTH = 691
export const MIN_MEDIUM_WIDTH = 692
export const MAX_MEDIUM_WIDTH = 1007
export const MIN_LARGE_WIDTH = 1008

// 1MB Unit Factor
export const MB_FACTOR = 1000000

// Maximum Upload Photo Size
export const MAX_UPLOAD_PHOTO_SIZE = 20

// Maximum Image Resolution
export const MAX_IMAGE_RESOLUTION = 36000000

// Photo Dimensions
export const MAX_WIDTH = 250
export const MAX_HEIGHT = 250

export const ACCEPTED_EXTENSIONS = ['image/avif', 'image/heif', 'image/jpeg', 'image/gif', 'image/png', 'image/webp']
